<template>
  <custom-page-template>
    <main-slide />
    <about-project id="about" />
    <about-uav />
    <recruiting-process id="recruit-process" />
    <df-mission />
    <uav-types />
    <grc-types />
    <popular-vacancy id="vacancy" />
    <subdivision-choose />
    <df-form id="form" />
  </custom-page-template>
</template>

<script>
import MainSlide from "@/components/main/mainSlide/MainSlide.vue";
import DfMission from "@/components/main/DroneForceMission.vue";
import AboutProject from "@/components/main/aboutProject/AboutProject.vue";
import AboutUav from "@/components/main/aboutUAV/AboutUAV.vue";
import RecruitingProcess from "@/components/main/recruinigProcess/RecruitingProcess.vue";
import UavTypes from "@/components/main/UAVTypes/UAVTypes.vue";
import GrcTypes from "@/components/main/GRCTypes/GRCTypes.vue";
import PopularVacancy from "@/components/main/popularVacancy/PopularVacancy.vue";
import SubdivisionChoose from "@/components/main/subDivisionChoose/SubDivisionChoose.vue";
import DfForm from "@/components/main/form/Form.vue";
import CustomPageTemplate from "@/components/templates/PageTemplate.vue";

export default {
  name: "main-page",
  components: {
    CustomPageTemplate,
    DfForm,
    SubdivisionChoose,
    PopularVacancy,
    GrcTypes,
    UavTypes,
    RecruitingProcess,
    AboutUav,
    AboutProject,
    DfMission,
    MainSlide,
  },
};
</script>
